export const features = [
  ['rpm', 'Remote Patient Monitoring'],
  ['kp-auto-ek12', 'KP Auto ek12'],
  ['qt', 'Enable ECG overread by KPSP'],
  ['qt-display-qt', 'Display QT value'],
  ['qt-display-qtcb', 'Display QTcb value'],
  ['hideqtcorrectiontype', 'Hide QT correction type'],
  ['qt-display-qtcf', 'Display QTcf value'],
  ['qt-display-rr', 'Display RR value'],
  ['qt-display', 'Display QT'],
  ['hide-overread-provider-info', 'Hide Overread Provider Info'],
  ['interpretation-service-provider', 'QT Interpretation Service Provider'],
  ['qt-service-provider', 'QT Service Provider Practice'],
  ['generalize-overread-provider-info', 'Generalize Overread Provider Info'],
  ['clinician-review-portal', 'Clinician Review Portal'],
  ['kpsp-error', 'Show Errors for Service Provider Practice'],
  ['referral', 'Referrals'],
  ['idtf', 'IDTF'],
  ['idtf-service-provider', 'IDTF Service Provider'],
  ['has-api-access', 'API Access'],
  ['medanta-api', 'Medanta API'],
  ['inventory', 'Inventory Management (IMP Phase 1)'],
  ['inventory-reporting', 'Inventory Reporting'],
  ['teleconnect', 'TeleConnect'],
  ['license-management', 'License Management'],
  ['web-onboarding', 'Web Onboarding'],
  ['12lead', '12 Lead'],
  ['ecw-integration', 'eCW Integration'],
  ['disable-connection-plan', 'Disable connection plan UI'],
  ['is-device-tutorials-enabled', 'Device Tutorials Enabled'],
  ['ebv', 'Enable Electronic Benefit Validation (eBV)'],
  ['technician-view-only', 'Technician View Only'],
  ['super-user', 'Enable super user'],
  ['enable-partner-pdf', 'Enable "Download Overread Report"'],
  ['inactive-practice', 'Inactive Practice'],
  ['hide-12l-interpretation-warning', 'Enable 12L Interpretation Warning Removal'],
  ['ecg-details-view', 'ECG details view']
]
export const featuresMap = new Map(features)

export const FEATURES = {
  INVENTORY: 'inventory',
  LICENSE_MANAGEMENT: 'license-management',
  SUPER_USER: 'super-user',
  INTERPRETATION_SERVICE_PROVIDER: 'interpretation-service-provider',
  QT_SERVICE_PROVIDER: 'qt-service-provider',
  MEDANTA_API: 'medanta-api',
  QT: 'qt',
  ECW_INTEGRATION: 'ecw-integration',
  TWELVE_LEAD: '12lead',
  DISABLE_CONNECTION_PLAN: 'disable-connection-plan',
  ECG_DETAILS_VIEW: 'ecg-details-view'
}

export const FEATURES_LABEL = {
  SUPER_USER_LABEL: 'Enable super user',
  INTERPRETATION_SERVICE_PROVIDER_LABEL: 'QT Service Provider Practice',
  QT_SERVICE_PROVIDER_LABEL: 'QT Interpretation Service Provider',
  ECW_INTEGRATION_LABEL: 'eCW Integration',
  TWELVE_LEAD_LABEL: '12 Lead',
  HIDE_QT_CORRECTION_TYPE_LABEL: 'Hide QT correction type',
  QT_LABEL: 'Enable ECG overread by KPSP'
}

export const checkFeatureEnabled = (FEATURE, teamFeatures) => {
  return teamFeatures ? teamFeatures.find(feature => {
    if (feature && feature.feature === FEATURE && feature.enabled === true) {
      return true
    }
  }) : false
}

export function checkCNOrigin() {
  const CN_URI = 'kardiapro.cn'
  // const LOCAL = 'localhost'
  return window.origin.includes(CN_URI) //|| window.origin.includes(LOCAL)
}

// Check if the origin is AliveCor China origin
export const checkIfFeatureSelected = (FEATURE, teamFeatures) => {
  return teamFeatures ? teamFeatures.find(feature => {
    if (feature && feature.feature === FEATURE) {
      return true
    }
  }) : false
}



// WEBPACK FOOTER //
// ./src/constants/features.js